module.exports = __webpack_public_path__ + "static/media/Lahore General Post Office c. 1910s.6bd8e956.jpg";